/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Hero Component
 */
/** @jsx jsx */

import { jsx } from '@emotion/react'
import { getHomepageTheme, getIsSpookyInterval } from '@zcode-ui/zumper-header'
import { Origin } from '@zcode/nr-utils'
import { Fragment } from 'react'
import { NavbarContainer } from '../navbar/NavbarContainer'
import { HomepageHeaderDesktop } from './HomepageHeaderDesktop/HomepageHeaderDesktop'
import { HomepageHeaderMobile } from './HomepageHeaderMobile/HomepageHeaderMobile'
import * as styles from './style'

export interface HeaderProps {
  homepageMainSearch: 'top-search'
  isMobile: boolean
  isZumperRentals: boolean
  now: number
  onClickSearchForm: () => void
}

export const Header = ({
  homepageMainSearch,
  isMobile,
  isZumperRentals,
  now,
  onClickSearchForm,
}: HeaderProps) => {
  const { HomepageMobileLogo } = getHomepageTheme(now)
  const showSpookyTheme = getIsSpookyInterval(now)

  return (
    <Fragment>
      <div css={styles.headerContainer}>
        {isMobile && (
          <div css={styles.navContainer}>
            <NavbarContainer origin={Origin.HOMEPAGE} />
          </div>
        )}
        {!isMobile && <NavbarContainer origin={Origin.HOMEPAGE} />}
        <div css={[styles.hero, showSpookyTheme && styles.heroHalloween]}>
          <div
            css={[
              styles.imageDimensions,
              isZumperRentals ? styles.imageZumperRentals : styles.image,
              showSpookyTheme && styles.imageHalloween,
            ]}
          />
          {isMobile && (
            <div css={styles.logo}>
              <HomepageMobileLogo size={48} />
            </div>
          )}
          {!isMobile && (
            <div css={styles.heroContent}>
              <div css={styles.headerContent}>
                <HomepageHeaderDesktop isZumperRentals={isZumperRentals} />
              </div>
            </div>
          )}
        </div>

        {isMobile && (
          <HomepageHeaderMobile
            homepageMainSearch={homepageMainSearch}
            onClickSearchForm={onClickSearchForm}
            isZumperRentals={isZumperRentals}
          />
        )}
      </div>
    </Fragment>
  )
}
